import * as z from "zod/v4";

export const getRedoLandmarkGlobalIntegration = {
  name: "getRedoLandmarkGlobalIntegration" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({ exists: z.boolean() }),
};
